import { CategoryId, StatusId } from "@hex/common";

import {
  CategoryFragment,
  StatusFragment,
} from "../../../app/ProjectLabels.generated";

export const decodeListFromQueryParams = (queryParam: string): string[] => {
  return queryParam
    .toLowerCase()
    .split(",")
    .map((name) => decodeURIComponent(name))
    .filter((name) => name.trim().length > 0);
};

export type Status = StatusFragment;
export type StatusMap = ReadonlyMap<StatusId, Status>;

export function toStatusMap(
  statuses: Status[] | readonly Status[] | undefined,
): StatusMap {
  if (statuses == null) return new Map();
  const map = new Map(statuses.map((status) => [status.id, status] as const));
  return map;
}

export type Category = CategoryFragment;
export type CategoryMap = ReadonlyMap<CategoryId, Category>;

export function toCategoryMap(
  categories: Category[] | readonly Category[] | undefined,
): CategoryMap {
  if (categories == null) return new Map();
  const map = new Map(
    categories.map((category) => [category.id, category] as const),
  );
  return map;
}
